<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
      <div class="d_flex_btwn">
        <h1 class="common_title">All Types</h1>
        <router-link class="btn btn_black" :to="{ name: 'create-types' }"
          >+ Add a New type</router-link
        >
      </div>
      <div class="ticket_contact_list_header">
        <div class="d_flex_btwn">
          <div class="order_filter_content">
            <div class="d_flex_start">
              <input
                type="text"
                class="form_global width_260p mr_5"
                placeholder="Search"
                v-model="queryParams.search"
              />
              <button
                class="btn btn_black mr_5 width_100p pt_10 pb_10"
                @click="searchQuery()"
              >
                Search
              </button>
              <button
                class="btn btn_black width_100p pt_10 pb_10 mr_5"
                @click="resetAll()"
              >
                Reset
              </button>
              <select
                name=""
                class="form_global width_150p mr_5"
                v-model="sort"
              >
                <option value="1">Name A-Z</option>
                <option value="2">Name Z-A</option>
                <option value="3">Modified</option>
              </select>
              <select
                name=""
                class="form_global width_150p mr_5"
                v-model="filter.status"
                @change="
                  queryParams.page = 1;
                  changeRoute();
                "
              >
                <option value="">All</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              <select
                name=""
                class="form_global width_150p"
                v-model="filter.per_page"
                @change="
                  queryParams.page = 1;
                  changeRoute();
                "
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </div>
          </div>

          <div class="d_flex_center">
            <top-pagination-component
              :pagination="pagination"
              @pageChanged="pageChanged"
            />
          </div>
        </div>
      </div>
      <div class="vlan_ticket_contact_list_page">
        <div class="vlan_ticket_contact_list_page_wrap">
          <div class="vlan_ticket_contact_list_inner">
            <div class="vlan_ticket_contact_list_inner_wrap">
              <ticket-table-component
                :columns="columns"
                :rows="types"
                :sortable="sortable"
                :pagination="pagination"
                @sorting="sorting"
                @pageChanged="pageChanged"
              >
                <template v-slot:status="{ row }">
                  <div class="form_checkbox">
                    <input
                      type="checkbox"
                      :id="'status_' + row.id"
                      :checked="row.status"
                      :value="row.status"
                    />
                    <label
                      :for="'status_' + row.id"
                      @click.prevent="changeActive($event, row)"
                    ></label>
                  </div>
                </template>

                <template v-slot:action="{ row }">
                  <router-link :to="`/types/${row.id}`">
                    <span title="Edit" class="pl_15 cursor_pointer"
                      ><img src="@/assets/media/images/edit.png" alt=""
                    /></span>
                  </router-link>
                  <span
                    title="Delete"
                    class="pl_15 cursor_pointer"
                    @click.prevent="deleteRecord(row)"
                    ><img src="@/assets/media/images/trash.png" alt=""
                  /></span>
                </template>
              </ticket-table-component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TicketTableComponent from '@/components/shared/TicketTableComponent';
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import TopPaginationComponent from '@/components/shared/TopPaginationComponent.vue';

// Hoisted so data(), setQueryData() and resetAll() share one definition of
// the unfiltered state: a param missing from the URL has to fall back to its
// default, never to undefined (axios drops those, and a dropped per_page
// makes the API return an unpaginated payload).
const defaultQueryParams = () => ({
  page: 1,
  search: '',
  search_columns: 'name',
  sort: 'created_at',
  sort_order: 'desc',
  per_page: 20,
});

const defaultFilter = () => ({
  status: '',
  per_page: 20,
});

export default {
  name: 'inventory-types',
  components: {
    LoaderMaskComponent,
    TicketTableComponent,
    TopPaginationComponent,
  },
  data() {
    return {
      lyLoading: false,
      types: [],
      sort: '1',
      filter: defaultFilter(),
      queryParams: defaultQueryParams(),
      sortable: {
        order: 'created_at',
        sort: 'desc',
      },
      columns: [
        {
          label: 'Name',
          field: 'name',
          sortable: true,
        },
        {
          label: 'Status',
          field: 'status',
          sortable: true,
          slot: true,
        },
        {
          label: 'Created At',
          field: 'created_at',
          sortable: true,
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false,
          slot: true,
        },
      ],
      pagination: null,
      update: {
        status: '',
      },
    };
  },
  created() {
    // Unconditional: partial deep links (?search=x) have to seed state too.
    this.setQueryData(this.getAllQueryParams());
    this.applyFilters();
  },
  mounted() {
    // if (this.$route.params.company_id) {
    //   this.queryParams.company_id = this.$route.params.company_id;
    //   setTimeout(() => {
    //     this.loadData();
    //   }, 200);
    // }
  },
  watch: {
    '$route.query': {
      handler() {
        this.applyFilters();
      },
      deep: true,
      immediate: true,
    },
    $route(to, from) {
      if (to.name == from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams());
        this.ticketingTableScroll();
        this.loadData();
      }
    },
    sort() {
      if (this.sort === '1') {
        this.sorting({ column: 'name', order: 'asc' });
      } else if (this.sort === '2') {
        this.sorting({ column: 'name', order: 'desc' });
      } else if (this.sort === '3') {
        this.sorting({ column: 'updated_at', order: 'desc' });
      }
    },
  },
  methods: {
    applyFilters() {
      const params = this.$route.params;
      console.log(params)
      if (params.company_id) this.queryParams.company_id = params.company_id;
      this.loadData();
    },
    setQueryData(query) {
      this.queryParams = this.withQueryDefaults(defaultQueryParams(), query);
      this.filter = this.withQueryDefaults(defaultFilter(), query);

      this.sortable = {
        order: this.queryParams.sort,
        sort: this.queryParams.sort_order,
      };
    },
    resetAll() {
      this.queryParams = defaultQueryParams();
      this.filter = defaultFilter();

      this.sortable = {
        order: this.queryParams.sort,
        sort: this.queryParams.sort_order,
      };

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      // A new search/filter changes the result set, so the old page number
      // no longer means anything — start from the first page.
      this.queryParams.page = 1;
      this.changeRoute();
    },
    sorting({ column, order }) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute();
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute();
    },
    deleteRecord(row) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/inventory-types/' + row.id).then(() => {
            this.ticketingTableScroll();
            this.loadData();
            this.$swal.fire('Deleted', 'Data has been deleted!', 'success');
          });
        }
      });
    },
    changeActive($e, row) {
      this.update.status = row.status;
      this.axios
        .post('/inventory-types/' + row.id+'/status', this.update)
        .then(() => {
          this.ticketingTableScroll();
          this.loadData();
          this.showSuccessMsg('Update Successfully!');
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    changeRoute() {
      this.$router.push({
        name: this.$route.name,
        query: { ...this.queryParams, ...this.filter },
      });
    },
    loadData() {
      this.lyLoading = true;
      this.axios
        .get('/inventory-types', {
          params: { ...this.queryParams, ...this.filter },
        })
        .then((response) => {
          this.ticketingTableScroll();
          this.types = response.data.data;
          this.pagination = response.data.meta;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
  },
};
</script>
<style scoped>
.color_green {
  text-decoration: underline;
  color: green;
}
</style>
